import { CommonModule, Location, ViewportScroller } from '@angular/common';
import { Component, ChangeDetectorRef, DestroyRef, Input, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { MaterialModule } from '../../../material/material.module';
import { PositionPipe } from '../../../shared/pipes/position.pipe';
import { PlayerShotPipe } from '../../../shared/pipes/player-shot.pipe';


import { AgentViewModel } from '../../../shared/models/AgentModels';
import { PlayerContactModel, PlayerTagPlayerViewModel, PlayerTagViewModel } from '../../../shared/models/player.model';

import { ScoutingPlayerService } from '../../../shared/services/scouting-player.service';
import { AgentService } from '../../../shared/services/agent.service';

import { PlayerScoutingChartsComponent } from '../../components/player-scouting-charts/player-scouting-charts.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ReportCardPlayerComponent } from '../../components/report-card-player/report-card-player.component';
import { NoteCardPlayerComponent } from '../../components/note-card-player/note-card-player.component';
import { PlayerRankingListEntryComponent } from '../../components/player-ranking-list-entry/player-ranking-list-entry.component';
import { AgentCardComponent } from '../../components/agent-card/agent-card.component';
import { PlayerContactCardComponent } from '../../components/player-contact-card/player-contact-card.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ReportTightPlayerComponent } from '../../components/report-tight-player/report-tight-player.component';
import { AgentSelectDialogComponent } from '../../components/agent-select-dialog/agent-select-dialog.component';
import { AddPlayerContactDialogComponent } from '../../components/add-player-contact-dialog/add-player-contact-dialog.component';
import { ChartPlayerProjectionComponent } from "../../components/chart-player-projection/chart-player-projection.component";
import { ReportDetailsDialogComponent } from '../../components/report-details-dialog/report-details-dialog.component';
import { FlowItemModel } from '../../../shared/models/FlowItemModel';
import { ResponseModel } from '../../../shared/models/ResponseModel';
import { SelectPlayerTagDialogComponent } from '../../components/select-player-tag-dialog/select-player-tag-dialog.component';


@Component({
    selector: 'app-player-details',
    imports: [CommonModule, MaterialModule, TranslateModule,
    ReportCardPlayerComponent, NoteCardPlayerComponent,
    PlayerRankingListEntryComponent, AgentCardComponent,
    PositionPipe, PlayerShotPipe,
    PlayerContactCardComponent, ChartPlayerProjectionComponent],
      
    templateUrl: './player-details.component.html',
    styleUrl: './player-details.component.css'
})
export class PlayerDetailsComponent {

  _playerData: any = null;
  _playerId: string;
  _agents: AgentViewModel[] = [];
  _reportmasterdata: any;
  _contacts: PlayerContactModel[] = [];
  @Input() PlayerId: string;
  _contactCount: number = 0;
  _playerTags: PlayerTagPlayerViewModel[] = [];
  _activeTags: PlayerTagViewModel[] = [];
  isLoading = signal<boolean>(false);
  
  IsFavoritePlayer = signal<boolean>(false);

  private route = inject(ActivatedRoute);
  private viewportScroller = inject(ViewportScroller);
  public playerService = inject(ScoutingPlayerService);
  private router = inject(Router);
  private location = inject(Location);
  private agentService = inject(AgentService);
  private _snackBar = inject(MatSnackBar);
  private dialog = inject(MatDialog);
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);

  constructor() {
  }

  ngOnInit() {
    this.route.paramMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(params => {
        const playerId = params.get('PlayerId') ?? '';
        if (!playerId || playerId === this._playerId) {
          if (!this._playerId) {
            this._playerId = playerId;
            this.loadPlayerDetails();
          }
          return;
        }

        this._playerId = playerId;
        this.loadPlayerDetails();
      });

    this.viewportScroller.scrollToPosition([0, 0]);
  }

  private loadPlayerDetails() {
    if (!this._playerId) {
      return;
    }

    this.isLoading.set(true);
    this._playerData = null;
    this._agents = [];
    this._contacts = [];
    this._playerTags = [];
    this._activeTags = [];
    this._reportmasterdata = null;

    this.playerService.getPlayerDetails(this._playerId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this._playerData = data;
        this.IsFavoritePlayer.set(data.IsFavourite || false);
        this.cdr.detectChanges();
        this.isLoading.set(false);
        this.loadSecondaryData(data.FlowPlayer.PositionId);
      });
  }

  private loadSecondaryData(positionId: string) {
    this.playerService.getReportMasterDataForPosition(positionId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(md => {
        this._reportmasterdata = md;
        this.cdr.detectChanges();
      });

    this.playerService.getPlayerContacts(this._playerId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(contacts => {
        this._contacts = contacts || [];
        this.cdr.detectChanges();
      });

    this.agentService.getAgentsForPlayer(this._playerId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this._agents = data || [];
        this.cdr.detectChanges();
      });

    this.loadPlayerTags();
    this.loadActiveTags();
  }


  
 
  openAddAgentDialog(){
    const dialogRef = this.dialog.open(AgentSelectDialogComponent, {
      width: '400px',     
    });
   

    dialogRef.afterClosed().subscribe(AgentId => {
      
      this.agentService.addAgentToPlayer(AgentId, this._playerId).subscribe(result=>{
        if(result){
          this.agentService.getAgentsForPlayer(this._playerId).subscribe(data=>{
            this._agents = data;
            this.cdr.detectChanges();
          });
          this.openSnackBar("Agent added", "CLOSE");
        }
          
        else
          this.openSnackBar("Failed", "CLOSE");
      });
    });
  }


  openAddContactDialog(){
    const dialogRef = this.dialog.open(AddPlayerContactDialogComponent, {
      width: '500px',
      data: {PlayerId: this._playerId}   
    });

    dialogRef.afterClosed().subscribe(result => {
      
      
        if(result){
          this.playerService.getPlayerContacts(this._playerId).subscribe(data=>{
            this._contacts = data;
            this.cdr.detectChanges();
          });
          this.openSnackBar("Contact added", "CLOSE");
        }          
        else
          this.openSnackBar("Failed", "CLOSE");
      });
    }
    
    

  refreshContacts(){
    this.playerService.getPlayerContacts(this._playerId).subscribe(data=>{
      this._contacts = data;
      this.cdr.detectChanges();
    });
  }

  refreshAgents(){
    this.agentService.getAgentsForPlayer(this._playerId).subscribe(data=>{
      this._agents = data;
      this.cdr.detectChanges();
    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  addTag(){
    const currentTagIds = new Set((this._playerTags || []).map(t => t.TagId));
    const availableTags = (this._activeTags || []).filter(t => !currentTagIds.has(t.TagId));

    if (availableTags.length === 0) {
      this.openSnackBar('No available tags', 'CLOSE');
      return;
    }

    const dialogRef = this.dialog.open(SelectPlayerTagDialogComponent, {
      width: '420px',
      data: { tags: availableTags }
    });

    dialogRef.afterClosed().subscribe((selectedTagId: string | null) => {
      if (!selectedTagId) {
        return;
      }

      this.playerService.addTagToPlayer(this._playerId, selectedTagId).subscribe(resp=>{
        if(this.isSuccessResponse(resp)){
          this.loadPlayerTags();
          this.openSnackBar('Tag added', 'CLOSE');
        }
        else{
          this.openSnackBar(resp?.Message || 'Failed', 'CLOSE');
        }
      });
    });
  }

  removeTag(tagId: string){
    this.playerService.removeTagFromPlayer(this._playerId, tagId).subscribe(resp=>{
      if(this.isSuccessResponse(resp)){
        this.loadPlayerTags();
        this.openSnackBar('Tag removed', 'CLOSE');
      }
      else{
        this.openSnackBar(resp?.Message || 'Failed', 'CLOSE');
      }
    });
  }

  private loadPlayerTags(){
    this.playerService.getTagsForPlayer_ByUser(this._playerId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(tags=>{
      this._playerTags = tags || [];
      this.cdr.detectChanges();
    });
  }

  private loadActiveTags(){
    this.playerService.getActivePlayerTags()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(tags=>{
      this._activeTags = tags || [];
      this.cdr.detectChanges();
    });
  }

  private isSuccessResponse(resp: ResponseModel | boolean | null | undefined): boolean {
    if (typeof resp === 'boolean') {
      return resp;
    }

    return !!resp?.Success;
  }

  back(){
    this.location.back();
  }

  openReportDetails(item: FlowItemModel) {
    this.dialog.open(ReportDetailsDialogComponent, {
      width: '100vw',
      maxWidth: '450px',
      height: '100dvh',
      maxHeight: '100dvh',
      panelClass: 'side-dialog',
      position: { right: '0' },
      data: {
        ReportId: item?.ReportId,
        CanEdit: item?.IsCreatedByCurrentUser
      }
    });
  }

  addAsFavorite(){
    this.playerService.addPlayerAsFavorite(this._playerId).subscribe(result=>{
      if(result){
        this.openSnackBar("Player added to favorites", "CLOSE");        
        this.IsFavoritePlayer.set(true);
      }
      else
        this.openSnackBar("Failed", "CLOSE");
    });
  } 

  removeAsFavorite(){
    this.playerService.removePlayerAsFavorite(this._playerId).subscribe(result=>{
      if(result){
        this.openSnackBar("Player removed from favorites", "CLOSE");
        
        this.IsFavoritePlayer.set(false);
      }
      else
        this.openSnackBar("Failed", "CLOSE");
    });
  }
}

